import { z } from "zod";
import { ActionSchema, QuestionAnalysisSchema, QuestionCardSchema, ReflectionSchema } from "@/ai/schemas";
import { sceneOrder, type V2Scene } from "./types";

export const DRAFT_KEY = "red-boat-v2-journey-v1";
const schema = z.object({
  version: z.literal(1), scene: z.custom<V2Scene>(v => sceneOrder.includes(v as V2Scene)),
  sessionId: z.string().min(1), question: z.string().max(120),
  analysis: QuestionAnalysisSchema.nullable(), questionTwo: QuestionCardSchema.nullable(),
  firstChoice: z.enum(["A", "B"]).nullable(), secondChoice: z.enum(["A", "B"]).nullable(),
  dedication: z.string().max(80), reflection: ReflectionSchema.nullable(),
  action: z.string().max(80), actionResult: ActionSchema.nullable(),
  ticket: z.object({ action: z.string(), templateNo: z.string(), ticketCode: z.string(), issuedDate: z.string() }).nullable(),
  caseSeen: z.boolean(), recallStep: z.number().int().min(0).max(2),
});
export type JourneyDraft = z.infer<typeof schema>;

export function readDraft(): JourneyDraft | null {
  try {
    const result = schema.safeParse(JSON.parse(sessionStorage.getItem(DRAFT_KEY) ?? "null"));
    if (!result.success) return null;
    const draft = result.data;
    // Resume at a usable screen if a refresh interrupted an async request/transition.
    if (draft.scene === "first" && draft.firstChoice) {
      if (draft.questionTwo) draft.scene = "struggle";
      else draft.firstChoice = null;
    }
    if (draft.scene === "struggle" && draft.secondChoice) draft.scene = "dedication";
    if ((draft.scene === "reflection" || draft.scene === "theory") && !draft.reflection) draft.scene = "dedication";
    return draft;
  } catch { return null; }
}

export function saveDraft(draft: JourneyDraft) {
  try { sessionStorage.setItem(DRAFT_KEY, JSON.stringify(draft)); } catch { /* Storage can be unavailable; the current journey still works. */ }
}
